import axios from '@axios'

export const state = {
  makes: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allMakes: (state) => state.makes,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  CLEAR_MAKE_STATE: (state) => {
    state.makes = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPage = 1
    state.totalRecord = 0
  },
  GET_MAKES: (state, resp) => {
    if (!resp) return null
    state.makes = resp.makes
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  CREATE_MAKE: (state, make) => {
    make.id = new Date().getTime()
    state.makes.push(make)
  },
  UPDATE_MAKE: (state, make) => {
    for (let i = 0; i < state.makes.length; i++) {
      if (state.makes[i].id === make.id) {
        make.id = new Date().getTime()
        for (let field in state.makes[i]) {
          state.makes[i][field] = make[field]
        }
        break
      }
    }
  },
  REMOVE_MAKE: (state, make) => {
    state.makes = state.makes.filter((m) => m.id !== make.id)
  },
}

export const actions = {
  async getMakes({ commit }) {
    commit('CLEAR_MAKE_STATE')
    await axios
      .get(`/api/makes`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_MAKE_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_MAKES', data)
        }
      })
      .catch(() => {
        commit('GET_MAKES', null)
      })
  },
  async createMake({ commit }, make) {
    return axios.post('/api/makes', make)
  },
  async updateMake({ commit }, make) {
    return axios.put('/api/makes', make)
  },
  async deleteMake({ commit, dispatch }, make) {
    await axios.delete('/api/makes', { data: make }).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_MAKE', make)
        let notification = {
          id: Date.now(),
          type: 'success',
          title: 'DELETE',
          message: 'The make has been deleted',
        }
        dispatch('notification/addNotification', notification, { root: true })
      }
    })
  },
}
